exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-license-button[data-v-698ef3b8]{align-items:center\n}\n.expired[data-v-698ef3b8]{color:#d33 !important\n}\n.draft[data-v-698ef3b8]{color:#f90 !important\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-698ef3b8","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/license/LicenseSelector.vue
// module id = 197
// module chunks = 0